module.exports = __webpack_public_path__ + "static/media/text.52ca89ff.svg";